import React, { useState } from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import Servicibility from '../components/Servicibility/Servicibility'
import { pinCodeList } from '../data/pinCodeData'
import ServiceTable from '../components/Servicibility/ServiceTable'

const CheckServicibility = () => {
  const [pinCode, setPinCode] = useState("")
  const [pinCodeDetail, setPinCodeDetail] = useState({})
  const handleCheckPinCode = () => {
    if (pinCode.length === 0 || pinCode.length !== 6) {
      alert('Please enter a valid Pin Code')
    }
    else {
      let matchedPin = null
      pinCodeList.forEach((pin) => {
        if (pin.Pin === Number(pinCode)) {
          matchedPin = pin
        }
      })
      if (!matchedPin) {
        alert('This pin code is not serviceable')
        setPinCodeDetail({})
        return
      }
      setPinCodeDetail(matchedPin)
      setPinCode("")
    }
  }
  return (
    <div className='flex bg-slate-100/80'>
      <Sidebar />

      <div className='flex h-[100vh] flex-1 flex-col overflow-y-scroll' >
        <Topbar />

        <div className='mx-4 pb-6 md:mx-6' >
          <Servicibility handleCheckPinCode={handleCheckPinCode} pinCodeDetail={pinCodeDetail} pinCode={pinCode} setPinCode={setPinCode} />
          {Object.keys(pinCodeDetail).length !== 0 && <ServiceTable pinCodeDetail={pinCodeDetail} pinCode={pinCode} />}
        </div>
      </div>
    </div>
  )
}

export default CheckServicibility
